import { preloadAttachmentBlockOnSend } from 'owa-attachment-block-on-send';
import type AttachmentWellHost from 'owa-calendar-meeting-forms-common-store/lib/store/schema/AttachmentWellHost';
import type { ClientAttachmentId, ClientItemId } from 'owa-client-ids';
import {
    lazyCreateAttachmentsViaQueueManager,
    AttachmentFileList,
    CreateAttachmentsProperties,
    OnAttachmentCreatedCallback,
    OnAttachmentCanceledOrFailedCallback,
} from 'owa-attachment-well-data';
import type { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export default function createAttachments(
    attachmentWellHost: AttachmentWellHost,
    parentItemId: ClientItemId,
    files: AttachmentFileList,
    createAttachmentProperties: CreateAttachmentsProperties,
    formId: string,
    infoBar?: InfoBarHostViewState,
    onFinish?: (attachmentId: ClientAttachmentId) => void,
    onAttachmentCreatedCallback?: OnAttachmentCreatedCallback,
    onAttachmentCanceledOrFailedCallback?: OnAttachmentCanceledOrFailedCallback,
    tryAgainCallback?: () => void
) {
    preloadAttachmentBlockOnSend.import();
    lazyCreateAttachmentsViaQueueManager.import().then(createAttachmentsViaQueueManager => {
        createAttachmentsViaQueueManager(
            attachmentWellHost.attachmentWell,
            parentItemId,
            files,
            infoBar,
            createAttachmentProperties,
            onFinish,
            onAttachmentCreatedCallback,
            onAttachmentCanceledOrFailedCallback,
            tryAgainCallback
        );
    });
}
